import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { ProductsService } from '../../shared/services/products.service';
import * as ProductsActions from '../actions/products.actions';

@Injectable()
export class ProductsEffects {
  private _actions$ = inject(Actions);
  private _productsService = inject(ProductsService);

  loadFamilies$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ProductsActions.loadProductFamilies),
      switchMap(() =>
        this._productsService.fetchFamilies().pipe(
          map((families) => ProductsActions.loadProductFamiliesSuccess({ data: families })),
          catchError((error) => of(ProductsActions.loadProductFamiliesFailure({ error })))
        )
      )
    )
  );

  loadTraits$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ProductsActions.loadProductTraits),
      switchMap(() =>
        this._productsService.fetchTraits().pipe(
          map((traits) => ProductsActions.loadProductTraitsSuccess({ data: traits })),
          catchError((error) => of(ProductsActions.loadProductTraitsFailure({ error })))
        )
      )
    )
  );

  loadTreatments$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ProductsActions.loadProductTreatments),
      switchMap(() =>
        this._productsService.fetchTreatments().pipe(
          map((treatments) => ProductsActions.loadProductTreatmentsSuccess({ data: treatments })),
          catchError((error) => of(ProductsActions.loadProductTreatmentsFailure({ error })))
        )
      )
    )
  );

  loadPackageTypes$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ProductsActions.loadProductPackageTypes),
      switchMap(() =>
        this._productsService.fetchPackageTypes().pipe(
          map((packageTypes) => ProductsActions.loadProductPackageTypesSuccess({ data: packageTypes })),
          catchError((error) => of(ProductsActions.loadProductPackageTypesFailure({ error })))
        )
      )
    )
  );

  loadGradeSizes$ = createEffect(() =>
    this._actions$.pipe(
      ofType(ProductsActions.loadProductGradeSizes),
      switchMap(() =>
        this._productsService.fetchGradeSizes().pipe(
          map((gradeSizes) => ProductsActions.loadProductGradeSizesSuccess({ data: gradeSizes })),
          catchError((error) => of(ProductsActions.loadProductGradeSizesFailure({ error })))
        )
      )
    )
  );
}
